export const getAddOnIds = (addOns) => {
  return Object.fromEntries(
    Object.entries(addOns).map(([key, value]) => [
      key,
      value.map((addon) => addon.id)
    ])
  )
}

/**
 * Extracts add-ons and generic add-ons from a package.
 * Uses the package's add_on_ids (configured add-ons) and identifies which are generic.
 *
 * @param {Object} pack - The package object
 * @param {Object} pack.add_on_ids - Map of product IDs to add-on IDs configured in the package
 * @param {Array} pack.products - Products in the package, each with add_ons array
 * @returns {{ addOns: Object, genericAddOns: Array }} - The add-ons map and generic add-on IDs
 */
export const getPackageAddOns = (pack) => {
  const products = pack.products || []
  const addOns = pack.add_on_ids || {}

  // Build a map of all add-ons from products to look up generic flag
  const addOnMap = {}
  products.forEach((product) => {
    product.add_ons?.forEach((addon) => {
      addOnMap[addon.id] = addon
    })
  })

  // Extract generic add-ons from the package's add_on_ids
  const genericAddOns = []
  Object.values(addOns)
    .flat()
    .forEach((addonId) => {
      if (addOnMap[addonId]?.generic) {
        genericAddOns.push(addonId)
      }
    })

  return { addOns, genericAddOns }
}
